import React from 'react'
import PropTypes from 'prop-types'
import ReactHtmlParser from 'react-html-parser'

const Wysiwyg = (props) => (
  <div className='wysiwyg'>
    {ReactHtmlParser(props.content)}
  </div>
)

Wysiwyg.propTypes = {
  content: PropTypes.string.isRequired
}

export default Wysiwyg



// WEBPACK FOOTER //
// ./src/components/Page/Content/Wysiwyg/index.js